import { API_LOGTRACE_URL } from "../configs/AppConfig";

const trace = ({traceObj}) => {
    console.log("Universal function called!");
    const accountid = localStorage.getItem("accountId")?`${localStorage.getItem("accountId")}`:'null';
    const appName = "extremeb2b";
    const customer = localStorage.getItem("businessName");
    const username = localStorage.getItem("username");
    const accountId = localStorage.getItem("accountId");
    const header = {
      "Content-Type": "application/json",
      "folderName" : "extremeb2b/dev"
    }
    let device = "desktop"
    if (/Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      device = "mobile"
    }
    const data = {
      "instance":API_LOGTRACE_URL,
      "customer":customer,
      "accountId":accountId,
      "type":traceObj.type,
      "event":traceObj.event,
      "device":device,
      "app":appName,
      "app_user":username,
      "customer_user":window?.idw?.customData && window?.idw?.customData?.UserID?window?.idw?.customData?.UserID:'',
      "additional_info":window?.idw?.customData?window?.idw?.customData:{},
      "message":traceObj.message,
      "status": traceObj.status
  }
  if(traceObj.action){
    data.action = traceObj.action
  }
  if(traceObj.referer_action_id){
    data.referer_action_id = traceObj.referer_action_id
  }
  if(traceObj.trackId){
    data.trackId = traceObj.trackId
  }
  if(traceObj.user_session){
    data.user_session = traceObj.user_session
  }
  

  if(traceObj.document_id){
    data.document_id = traceObj.document_id
  }
  console.log(data);
    fetch(
      // `https://qaenv-bnh3qyskom.extremeb2b.com/logtrace/${accountid}/track`,
      `${API_LOGTRACE_URL}/logtrace/${accountid}/track`,
     {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      redirect: "follow", // manual, *follow, error
      headers: header,
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })
  };

  export default trace;